module.exports = __webpack_public_path__ + "static/media/1stepForward.28728eb2.webp";